import React from 'react';
import { MenuItem, Select } from '@mui/material';
import { z } from 'zod';

import { ReadabilityMode } from '../../theme/readability-mode';
import { useLocalStorage } from '../../utils/use-session-storage';
import { FormattedMessage } from 'react-intl';

export const ReadabilityModeSelect = () => {
  const [readabilityMode, setReadabilityMode] = useLocalStorage(
    z.nativeEnum(ReadabilityMode),
    'readabilityMode',
    ReadabilityMode.Default
  );

  return (
    <Select
      sx={{ ml: 'auto' }}
      value={readabilityMode}
      onChange={(e) => {
        const newValue = e.target.value as ReadabilityMode;
        if (newValue !== readabilityMode) {
          setReadabilityMode(newValue);
          setTimeout(() => {
            window.location.reload();
          }, 100);
        }
      }}
    >
      <MenuItem value={ReadabilityMode.Default}>
        <FormattedMessage
          id="settings.readability_mode.default"
          defaultMessage="Výchozí"
        />
      </MenuItem>
      <MenuItem value={ReadabilityMode.Large}>
        <FormattedMessage
          id="settings.readability_mode.large"
          defaultMessage="Velká"
        />
      </MenuItem>
    </Select>
  );
};
